import { render, staticRenderFns } from "./PartnerProductsSection.vue?vue&type=template&id=36ea1dbf&scoped=true&"
import script from "./PartnerProductsSection.vue?vue&type=script&lang=js&"
export * from "./PartnerProductsSection.vue?vue&type=script&lang=js&"
import style0 from "./PartnerProductsSection.vue?vue&type=style&index=0&id=36ea1dbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea1dbf",
  null
  
)

export default component.exports